// extracted by mini-css-extract-plugin
module.exports =  {"buttons":"Buttons-module__buttons___WeSX_"};